goog.provide("shadow.js.shim.module$ol$Map$default");
shadow.js.shim.module$ol$Map$default = shadow.js.require(386, {})["default"];
